import axios from "axios";

export const authenticate = (nickname: string) =>
  axios.post<string>("/auth/new", { nickname });

export const refreshToken = () => axios.post<string>("/auth/refresh-token");
